import Profile from 'components/mypage/Profile';

export default function Mypage() {
  return (
    <>
      <Profile />
    </>
  );
}
